import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, LANGUAGES } from "../i18n/translations";
import { api } from "../lib/api";

const LanguageContext = createContext(null);

export const useLang = () => useContext(LanguageContext);

const getInitialLang = () => {
  const saved = localStorage.getItem("vytali_lang");
  if (saved && translations[saved]) return saved;
  return "fr";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((code) => {
    if (translations[code]) {
      localStorage.setItem("vytali_lang", code);
      setLangState(code);
    }
  }, []);

  // Auto-detect language by IP on first visit (no manual choice saved yet).
  useEffect(() => {
    if (localStorage.getItem("vytali_lang")) return;
    let cancelled = false;
    api.get("/geo/locale")
      .then((r) => {
        if (!cancelled && r.data?.lang && translations[r.data.lang]) {
          setLangState(r.data.lang);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.fr[key] ?? key,
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
